export default __webpack_public_path__ + "static/media/36-BeachKereru.b469d5ff.jpeg";